import fetchAPI from '../../../lib/utils/fetch-api'
import {
  setClaimWorkFormFailed,
  setClaimWorkFormLoading,
  setClaimWorkFormAlert,
  setClaimWorkFormData,
} from './actions'

export function getClaimWorkData(id: number | string) {
  return async dispatch => {
    dispatch(setClaimWorkFormLoading())
    try {
      const response = (await fetchAPI(`/api/claim-work/${id}`)) || []
      if (response['errors'] || response?.error) {
        let error = response['errors'] || response?.error
        if (Array.isArray(error)) {
          error = error.join()
        }
        return dispatch(setClaimWorkFormFailed(error))
      }
      return dispatch(setClaimWorkFormData(response))
    } catch (err) {
      console.error(err)
      return dispatch(setClaimWorkFormFailed('При загрузки полей возникла ошибка'))
    }
  }
}

interface IClaimWorkPostData {
  stage?: string
  dealer_code?: number
}

export function updateFormData(id: string | number, data: IClaimWorkPostData) {
  return async dispatch => {
    try {
      const response = await fetchAPI(`/api/claim-work/${id}`, {
        method: 'POST',
        body: JSON.stringify(data),
      })

      if (response['errors']) {
        let error = response['errors']
        if (Array.isArray(error)) {
          error = error.join()
        }
        return dispatch(setClaimWorkFormFailed(error))
      }
      return dispatch(setClaimWorkFormData(response))
    } catch (err) {
      return dispatch(setClaimWorkFormFailed(err as string))
    }
  }
}

export function nextStage(id, formData) {
  return async dispatch => {
    try {
      const response = await fetchAPI(`/api/claim-work/${id}`, {
        method: 'POST',
        body: JSON.stringify(formData),
      })

      if (response?.['alert']) {
        const alert = response['alert']
        dispatch(setClaimWorkFormAlert(alert))
        return dispatch(setClaimWorkFormAlert(null))
      }

      if (response['errors']) {
        let error = response['errors']
        if (Array.isArray(error)) {
          error = error.join()
        }
        return dispatch(setClaimWorkFormFailed(error))
      }
      return dispatch(setClaimWorkFormData(response))
    } catch (err) {
      return dispatch(setClaimWorkFormFailed(err as string))
    }
  }
}
